import { createContext } from 'react';

const MobileGridContext = createContext();

export default MobileGridContext;
